import Image from 'components/Image'
import Paragraph from 'components/Paragraph'
import Button from 'components/Button'
import Link from 'components/Link'

import Styled from './styled'

const imageDashboard = '/assets/images/client_dashboard_red.png'

export default function SectionBusiness({ data }) {
  const description = data?.description
  const buttonText = data?.button?.text
  const buttonUrl = data?.button?.url
  const icon = data?.icon?.url

  return (
    <Styled>
      <div className="left-block">
        <div className="content-left-block">
          <Image src={icon} className="image-logo" />

          <div className="detail">
            <Paragraph>{description}</Paragraph>
          </div>
          <div className="button-block">
            <Link href={buttonUrl} openNewTab>
              <Button size="large">{buttonText}</Button>
            </Link>
          </div>
        </div>
      </div>

      <div className="right-block">
        <div className="image-block">
          <Image src={imageDashboard} />
        </div>

        <div className="button-block">
          <Link href={buttonUrl} openNewTab>
            <Button size="large">{buttonText}</Button>
          </Link>
        </div>
      </div>
    </Styled>
  )
}
